module.exports = {
      id: "gzhome-usage",
      viewBox: "0 0 29.037 17.12",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#gzhome",
      toString: function () {
        return this.url;
      }
    }